import React from "react";

export const PostContext = React.createContext();
export const ModalContext = React.createContext();
export const RequestCall = React.createContext();